import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { errorToast } from "../components/Toast";
import { generatePassword } from "../helpers/utils";

class UserPasswordView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: this.props.userId,
      newPassword: "",
      confirmPassword: "",
      passwordGenerator: generatePassword()
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    let valid = this.handlePasswordMatch();
    if (valid) {
      this.props.onSubmit({ id: this.state.userId, password: this.state.newPassword });
    } else {
      errorToast({ message: "Pola 'Nowe hasło' i 'Potwierdź hasło' muszą być identyczne" });
    }
  };

  handleCancel = e => {
    e.preventDefault();
    this.props.onCancel();
  };

  handleRefreshPassword = e => {
    e.preventDefault();
    this.setState({
      passwordGenerator: generatePassword()
    })
  };

  handlePasswordMatch = () => {
    if (this.state.newPassword === this.state.confirmPassword) {
      return true;
    }
    return false;
  }

  handleNewPasswordChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ newPassword: value });
  };

  handleConfirmPasswordChange = e => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ confirmPassword: value });
  };

  render() {

    return (
      <div className="w3-card-4">
        <div className="w3-container w3-theme">
          <h2 className="w3-center">{this.props.title}</h2>
        </div>

        <form className="w3-container" onSubmit={this.handleSubmit}>

          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="password"

                name="newPassword"
                onChange={this.handleNewPasswordChange}
                value={this.state.newPassword}
                required
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="user.newPassword" defaultMessage="newPassword" />
              </label>
            </div>

            <div className="w3-col s1">
              <button
                className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
                onClick={this.handleRefreshPassword}
              >
                <i className="fas fa-sync" />
              </button>
            </div>

            <div className="w3-col s5">
              <input
                className="w3-input"
                type="text"
                name="passwordGenerator"
                value={this.state.passwordGenerator}
                disabled
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="user.passwordGenerator" defaultMessage="PasswordGenerator" />
              </label>

            </div>
          </div>

          <div className="w3-row-padding">
            <div className="w3-col s6">
              <input
                className="w3-input"
                type="password"
                name="confirmPassword"
                onChange={this.handleConfirmPasswordChange}
                value={this.state.confirmPassword}
                required
              />
              <label className="w3-text-theme w3-small">
                <FormattedMessage id="user.confirmPassword" defaultMessage="confirmPassword" />
              </label>
            </div>
          </div>

          <div className="w3-bar">
            <button
              className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
              type="submit"
            >
              {this.props.sumbitText}
            </button>
            <button
              className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
              type="reset"
              onClick={this.handleCancel}
            >
              {this.props.cancelText}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

UserPasswordView.propTypes = {
  title: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  cancelText: PropTypes.string.isRequired,
  sumbitText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default UserPasswordView;
